'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _functional = require('../utils/functional');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

require('flickity-as-nav-for');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modals = function modals(el) {
  (0, _classCallCheck3.default)(this, modals);

  // Close Product Modal
  (0, _jquery2.default)('[data-closeModal=product_modal]').click(function () {
    (0, _jquery2.default)('.mod-Modal').removeClass('mod-Modal-open');
    (0, _jquery2.default)('body').removeClass('no-scroll');

    setTimeout(function () {
      (0, _jquery2.default)('.mod-Modal .prd-AccordionOpener').removeClass('prd-AccordionOpener-open');
      (0, _jquery2.default)('.mod-Modal .prd-AccordionBody').removeClass('prd-AccordionBody-open');
    }, 750);
  });

  /* Product Modals w/ Tabs */
  var carouselInitialised = false;

  (0, _jquery2.default)('.prd-AccordionBody .mod-Modal_Open').click(function (e) {
    var el = (0, _functional.getElement)('.mod-Modal[data-modal=' + (0, _jquery2.default)(this).data('modal') + ']');

    (0, _jquery2.default)('.mod-Modal[data-modal=' + (0, _jquery2.default)(this).data('modal') + ']').addClass('mod-Modal-open');
    (0, _jquery2.default)('body').addClass('no-scroll');

    (0, _jquery2.default)('.mod-Modal .prd-AccordionOpener[data-tab-handle=' + (0, _jquery2.default)(this).data('tab-handle') + ']').addClass('prd-AccordionOpener-open');
    (0, _jquery2.default)('.mod-Modal .prd-AccordionBody[data-tab-handle=' + (0, _jquery2.default)(this).data('tab-handle') + ']').addClass('prd-AccordionBody-open');

    if ((0, _jquery2.default)(this).data('tab-handle') === 'stone-colours' && carouselInitialised === false) {
      var mainCarousel = new _flickity2.default((0, _functional.getElement)('.car-Slides_Items-carousel', { context: el }), {
        wrapAround: false,
        pageDots: false,
        initialIndex: 1,
        cellAlign: 'center'
      });

      var carouselNav = new _flickity2.default((0, _functional.getElement)('.car-Slides_Items-carousel-nav', { context: el }), {
        asNavFor: (0, _functional.getElement)('.car-Slides_Items-carousel', { context: el }),
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        wrapAround: false,
        draggable: false,
        prevNextButtons: false
      });

      carouselInitialised = true;

      mainCarousel.resize();
      carouselNav.resize();
    }

    e.preventDefault();
  });

  // Click outside of modal to close
  (0, _jquery2.default)(document).click(function (e) {
    // Product modal
    if ((0, _jquery2.default)(e.target).is('.mod-Modal[data-modal=tab_modal]')) {
      e.preventDefault();
      (0, _jquery2.default)('.mod-Modal').removeClass('mod-Modal-open');
      (0, _jquery2.default)('body').removeClass('no-scroll');

      setTimeout(function () {
        (0, _jquery2.default)('.mod-Modal .prd-AccordionOpener').removeClass('prd-AccordionOpener-open');
        (0, _jquery2.default)('.mod-Modal .prd-AccordionBody').removeClass('prd-AccordionBody-open');
      }, 750);
    }

    // Newsletter modal
    if ((0, _jquery2.default)(e.target).is('.mod-Modal[data-modal=newsletter]')) {
      e.preventDefault();
      (0, _jquery2.default)('.mod-Modal').removeClass('mod-Modal-open');
      (0, _jquery2.default)('body').removeClass('no-scroll');
      _jsCookie2.default.set('newsletter-modal-template', 1);
    }
  });

  /* ============================================================================
  # Newsletter Modal
  ============================================================================== */

  // Close Newsletter Modal
  var modal = (0, _jquery2.default)('.mod-Modal');
  (0, _jquery2.default)('[data-closeModal=newsletter_modal]').click(function () {
    modal.removeClass('mod-Modal-open');
    (0, _jquery2.default)('body').removeClass('no-scroll');
    _jsCookie2.default.set('newsletter-modal-template', 1);
  });

  (0, _jquery2.default)('.new-Newsletter_Form form').submit(function (e) {
    (0, _jquery2.default)('body').removeClass('no-scroll');
    _jsCookie2.default.set('newsletter-modal-template', 1);
  });

  // Show automatically based on cookies
  var newsletterModal = (0, _jquery2.default)('.mod-Modal[data-modal=newsletter]');
  var timeUntilAppear = parseInt(newsletterModal.data('time-until-appear'), 10) * 1000;
  setTimeout(function () {
    if (_jsCookie2.default !== undefined && _jsCookie2.default.get('newsletter-modal-template') == null) {
      newsletterModal.addClass('mod-Modal-open');
    } else {
      newsletterModal.removeClass('mod-Modal-open');
    }
  }, timeUntilAppear);
};

exports.default = modals;